module.exports = ":host(.edit-section-login) {\n  background-color: #fafafa;\n  height: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.less
// module id = ./src/app/app.component.less
// module chunks = main